import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 * ! 2023. 1. 3. 화
 * ! 정리 필요.
 * @param {boolean} localizing -> th가 3rem으로 폭이 줄어야 한다.
 * @returns {세로형 테이블}
 */
interface IProps {
  children: JSX.Element[] | JSX.Element;
  localizing?: boolean;
  preImage?: boolean;
  style?: React.CSSProperties;
  thWidth?: string;
  className?: string;
}
const VerticalTable = ({
  className,
  children,
  localizing,
  preImage,
  style,
  thWidth,
}: IProps) => {
  return (
    <Table
      className={className}
      localizing={localizing}
      preImage={preImage}
      style={style}
      thWidth={thWidth}
    >
      <tbody>{children}</tbody>
    </Table>
  );
};

export default VerticalTable;
const Table = styled.table<IProps>`
  /* border: 1px solid black; */
  width: 100%;
  /* margin-bottom: 2rem; */
  th {
    /* vertical-align: top; */
  }
  th,
  td {
    /* border: 1px solid black; */
    padding-top: 1.2rem;
    white-space: pre-line;
  }
  /* tr {
    display: flex;
  } */

  th {
    text-align: right;
    padding-left: 0rem;
    padding-right: 1.2rem;
    color: ${(props) => props.theme.colors.blueText};
    font-weight: 600;
    width: ${(props) =>
      props.thWidth
        ? props.thWidth
        : props.localizing
        ? '4rem '
        : props.preImage
        ? '9rem'
        : '7rem'};
  }
  td {
    width: ${(props) => (props.preImage ? '28rem' : '')};
  }
  .th_title {
    /* border: solid 2px blue; */
    padding: 0;
    position: absolute;
    left: 1.25rem;
    /* text-align: left; */
    font-weight: 700;
  }
  .main_title_tr {
    th {
      padding-top: 3rem;
      text-align: left;
    }
  }
  .top {
    th {
      padding-top: 1rem;
    }
  }
  .title_tr {
    th {
      font-weight: 700;
      text-align: right;
      width: 4rem;
    }
  }
  .lang_td {
    display: flex;
    align-items: center;
    padding-top: 2rem;
    p {
      font-weight: 700;
      font-size: 0.95rem;
      width: 5.7rem;
      text-align: right;
      padding-right: 0.8rem;
    }
  }
  /* 에피소드 수정 부분 */
  .first_tr {
    td:nth-child(2) {
      width: 12%;
    }
    td:nth-child(4) {
      width: 15%;
    }
  }
  /* 요약 th 부분 조정 */
  .summary_tr {
    th,
    td {
      padding-bottom: 2rem;
      /* padding-top: 2rem; */
    }
    th {
      vertical-align: baseline;
    }
  }

  .divider {
    border-bottom: 1px solid ${theme.colors.gray_4};
    height: 1rem;
    th {
      vertical-align: baseline;
    }
    td {
      padding-bottom: 2rem;
    }
  }

  .narrow_divider {
    border-bottom: 1px solid ${theme.colors.gray_4};
    th {
      vertical-align: baseline;
    }
    td {
      padding-bottom: 0.6rem;
    }
  }

  /* 운영관리-우편 검색 테이블 */
  .th_left {
    width: 7%;
    padding: 0.5rem 1rem;
  }
  .th_right {
    padding-left: 2rem;
    width: 9%;
  }
  .td_search_input {
    width: 40%;
    padding: 0.5rem 0rem;
  }

  .title {
    font-size: 1rem;
    color: ${theme.colors.blueText};
    font-weight: 700;
  }

  /* 능력치 수정 모달 부분 */
  .ability_tr {
    > th {
      /* border: solid 2px blue; */
      padding: 0;
    }
    > td {
      padding: 0;
      padding-left: 0.5rem;
    }
  }
  /* 운영 - 프로모션 */
  .promotion_type_td {
    display: flex;
    justify-content: space-between;
    > div {
      width: 100%;
      &:nth-child(1) {
        margin-right: 1rem;
      }
    }
  }

  /* 부가설명 */
  .description {
    font-size: 0.8rem;
    color: ${theme.colors.gray_5};
  }

  /* 광고 관리 테이블 */
  &.ad_table {
    width: 30rem;
    transform: translate(0, -1.25rem);
    th {
      width: 6rem;
    }
    td {
      width: 5rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    tr:nth-child(1) {
    }
  }
  &.ad_table2 {
    width: 70rem;
    th {
      width: 8rem;
    }
    td {
      width: 5rem;
    }
    tr:nth-child(1) {
    }
  }
  .th_color {
    th {
      color: ${theme.colors.black};
      font-weight: 700;
    }
  }

  .one_row_multi_column {
    /* border: solid 2px blue; */
    display: flex;
    justify-content: center;
    /* align-items: center; */
  }

  .ifyou_pass {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    h2 {
      margin: 1rem 0;
    }
    .flex {
      display: flex;
      margin-left: 2.5rem;
    }
    tr,
    td {
      display: flex;
    }
    .advertise {
      transform: translate(0rem, 0);
      text-align: right;
      padding-right: 1.2rem;
      color: ${(props) => props.theme.colors.blueText};
      font-weight: 600;
    }
  }
`;
